(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhp-brand-overview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bhp-motion-film')) customElements.define('bhp-motion-film', class extends HTMLElement {
connectedCallback(){
 this.abort?.abort(); this.abort=new AbortController(); const signal=this.abort.signal;
 this.video=this.querySelector('video');this.button=this.querySelector('button');
 this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.mobile=matchMedia('(max-width: 650px)');
 this.userPaused=false;
 const sync=()=>{this.button.textContent=this.video.paused?this.button.dataset.play:this.button.dataset.pause;};
 this.video.addEventListener('playing',()=>{this.setAttribute('data-playing','');sync();},{signal});
 this.video.addEventListener('pause',sync,{signal});
 this.video.addEventListener('error',()=>{this.removeAttribute('data-playing');this.button.hidden=true;},{signal});
 this.button.addEventListener('click',()=>{if(this.video.paused){this.userPaused=false;this.video.play().catch(()=>{this.removeAttribute('data-playing');sync();});}else{this.userPaused=true;this.video.pause();}},{signal});
 const preference=()=>{if(this.reduce.matches||this.mobile.matches){this.video.pause();this.removeAttribute('data-playing');this.button.hidden=true;}else if(!this.userPaused){this.start();}};
 this.reduce.addEventListener('change',preference,{signal});this.mobile.addEventListener('change',preference,{signal});
 this.observer=new IntersectionObserver(entries=>{for(const e of entries){if(!e.isIntersecting)this.video.pause();else if(!this.reduce.matches&&!this.mobile.matches&&!this.userPaused)this.start();}},{threshold:.15});this.observer.observe(this);
}
start(){if(!this.video.src){this.video.src=this.dataset.src;this.video.muted=true;}this.button.hidden=false;this.video.play().catch(()=>{this.removeAttribute('data-playing');this.button.textContent=this.button.dataset.play;});}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.video?.pause();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
